import { StopAPI } from '../../../api/spidermap/StopAPI';

export class StopsCommand {
    getAll(successCallback, errorCallback) {
        const apiResult = StopAPI.list();
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as paragens");
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/spidermap/commands/StopsCommand.js